"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteFaq = exports.UseCrudFaq = void 0;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const faq_api_1 = require("../../../../utils/api/faq/faq.api");
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const UseCrudFaq = (handleClose, item) => {
    const validationSchema = yup.object().shape({
        question: yup.string().required("La question est requise.").label("Question"),
        reponse: yup.string().required("La réponse est requise.").label("Réponse"),
        ordre: yup
            .number()
            .transform((value, originalValue) => (originalValue === "" ? null : value))
            .nullable()
            .min(0, "L'ordre doit être >= 0")
            .label("Ordre"),
    });
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, watch, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const [addOrUpdateFaq, { isLoading, isSuccess, error, isError }] = (0, faq_api_1.useAddOrUpdateFaqMutation)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `FAQ ${item ? "modifiée" : "ajoutée"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!item) {
                    reset();
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        addOrUpdateFaq({ id: item === null || item === void 0 ? void 0 : item.id, data });
    }, [addOrUpdateFaq, item === null || item === void 0 ? void 0 : item.id]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (item) {
            setValue("question", item === null || item === void 0 ? void 0 : item.question);
            setValue("reponse", item === null || item === void 0 ? void 0 : item.reponse);
            setValue("ordre", (_a = item === null || item === void 0 ? void 0 : item.ordre) !== null && _a !== void 0 ? _a : null);
        }
    }, [item]);
    return {
        register,
        errors,
        onSubmit: handleSubmit(onSubmit),
        isLoading,
        setValue,
        reponseValue: watch("reponse"),
    };
};
exports.UseCrudFaq = UseCrudFaq;
const UseDeleteFaq = (id) => {
    const [deleteFaq] = (0, faq_api_1.useDeleteFaqMutation)();
    const onDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cette FAQ ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield deleteFaq(id).unwrap();
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) || `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        if (result === null || result === void 0 ? void 0 : result.isConfirmed) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `FAQ supprimée avec succès !`,
                iconColor: theme_1.Color.themeColor,
                showConfirmButton: false,
                timer: 1500,
            });
        }
    });
    return onDelete;
};
exports.UseDeleteFaq = UseDeleteFaq;
